import React from "react";
import ExperienceCard from "./ExperienceCard";
function Experience() {
  return (
    <div className="experience">
      <ExperienceCard />
    </div>
  );
}

export default Experience;
